import { NgModule, APP_INITIALIZER, NO_ERRORS_SCHEMA } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalRedirectComponent } from '@azure/msal-angular';

//******************************************************************************
//  App Framework
//******************************************************************************
import { AppComponent } from './app.component';

//******************************************************************************
//  Services
//******************************************************************************
import { AppConfigService } from './services/appconfig.service';

//******************************************************************************
//  Core Imports
//******************************************************************************
import { CoreImports } from './classes/imports/core.imports';
import { CoreRouting } from './classes/routes/core.routing';

//******************************************************************************
//  App Imports
//******************************************************************************
import { AppImports } from '../classes/imports/app.imports';
import { AppRouting } from '../classes/routes/app.routing';

//******************************************************************************
//  Auth Classes (Guards/Factories)
//******************************************************************************
import { AuthGuard } from './classes/auth/auth.guard';
import * as auth from './classes/auth/auth.factories';

const authFactories = new auth.AuthFactories();

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        MsalModule,

        CoreImports,
        CoreRouting,

        AppImports,
        AppRouting,
    ],
    declarations: [
        AppComponent,
    ],
    providers: [
        AppConfigService,
        AuthGuard,
        {
            provide: APP_INITIALIZER,
            useFactory: authFactories.initializerFactory,
            deps: [AppConfigService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: authFactories.MSALInstanceFactory,
            deps: [AppConfigService]
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: authFactories.MSALGuardConfigFactory,
            deps: [AppConfigService]
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: authFactories.MSALInterceptorConfigFactory,
            deps: [AppConfigService]
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
    ],
    bootstrap: [
        AppComponent,
        MsalRedirectComponent,
    ],
    schemas: [
        NO_ERRORS_SCHEMA
    ]
})
export class AppModule { }
